import IncreaseYourLineOfCreditLimits from 'features/lineOfCredit/screens/IncreaseYourLineOfCreditLimits/IncreaseYourLineOfCreditLimits';
import React from 'react';

export default function IncreaseYourLineOfCreditLimitsPage() {
  return <IncreaseYourLineOfCreditLimits />;
}
